// extracted by mini-css-extract-plugin
module.exports =  {"buffering":"buffering-IgMNi","logo":"logo-GBPtk","pulse":"pulse-Aqwp7","background":"background-G3FHq"};